import React, { useState } from 'react';
import ListView from './ListView';
import MasterConfigView from './MasterConfigView';
import AddChildView from './AddChildView';
import PreviewView from './PreviewView';
import './DynamicComp.css';

function DynamicComp() {
  const [view, setView] = useState('list');
  const [editingChild, setEditingChild] = useState(null);
  const [draftFields, setDraftFields] = useState(null);
  const [hasOrderChanged, setHasOrderChanged] = useState(false);

  if (view === 'masterConfig') {
    return (
      <MasterConfigView
        onBack={() => {
          setDraftFields(null);
          setHasOrderChanged(false);
          setView('list');
        }}
        onPreview={() => setView('preview')}
        draftFields={draftFields}
        onDraftFieldsChange={setDraftFields}
        hasOrderChanged={hasOrderChanged}
        onHasOrderChangedChange={setHasOrderChanged}
      />
    );
  }

  if (view === 'addChild') {
    return (
      <AddChildView
        onBack={() => setView('list')}
        onMasterConfig={() => setView('masterConfig')}
      />
    );
  }

  if (view === 'editChild') {
    return (
      <AddChildView
        onBack={() => {
          setView('list');
          setEditingChild(null);
        }}
        editData={editingChild}
        onMasterConfig={() => setView('masterConfig')}
      />
    );
  }

  if (view === 'preview') {
    return <PreviewView onBack={() => setView('masterConfig')} previewFields={draftFields} />;
  }

  return (
    <ListView
      onMasterConfig={() => setView('masterConfig')}
      onAddChild={() => setView('addChild')}
      onEditChild={(child) => {
        setEditingChild(child);
        setView('editChild');
      }}
    />
  );
}

export default DynamicComp;
